export function getDescriptionForRole(role) {
  switch (role) {
    case 'ACCESS_MANAGER':
      return [
        'Allows access to User Access Dashboard',
        'Can create, review, update and delete all users for the institution'
      ]
    case 'ADMINISTRATOR':
      return [
        'Allows access to the entire application',
        'Can assign other users as Paradigm Administrators'
      ]
    case 'CASE_RESEARCHER':
      return [
        'Allows access to Assignments Dashboard and Assigned Cases',
        'Can be assigned a form and review cases in which they have an assignment'
      ]
    case 'CASE_REVIEWER':
      return ['Allows access to All Cases', 'Can review all cases within the institution']
    case 'CASE_MANAGER':
      return [
        'Allows access to all cases/patients',
        'Can create, review and update all cases/patients within the institution'
      ]
    case 'GENOMIC_TEST_REVIEWER':
      return ['Allows access to genomic testing notifications and preferences']
    case 'INSIGHTS_DASHBOARD_REVIEWER':
      return ['Allows access to Insights Dashboard']
    case 'PRESENTATION_MANAGER':
      return [
        'Allows access to presentations',
        'Can create, review, update and delete all presentations within the institution'
      ]
    case 'DEEP_LENS_COORDINATOR':
      return [
        'Provides Paradigm role specific capabilities including real time feasibility and trigger manual identification of patients for trials'
      ]
    case 'SLIDE_MANAGER':
      return [
        'Allows access to the Slides Dashboard',
        'Can create, review, update and delete all slides within the institution'
      ]
    case 'TRIALS_COORDINATOR':
      return ['Allows access to Trials Dashboard', 'Can review and update patient criteria']
    case 'TRIAL_REVIEWER':
      return ['Allows access to Trials Dashboard', 'Can review all trial-related data']
    default:
      return []
  }
}
